import { render, staticRenderFns } from "./companyInfoModel.vue?vue&type=template&id=44a8a0e9&scoped=true&"
import script from "./companyInfoModel.vue?vue&type=script&lang=js&"
export * from "./companyInfoModel.vue?vue&type=script&lang=js&"
import style0 from "./companyInfoModel.vue?vue&type=style&index=0&id=44a8a0e9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a8a0e9",
  null
  
)

export default component.exports